/** * 支付流程中签约 */
<template>
  <vix-suspend-menu
    class="suspend-container"
    :class="{ 'large-height-page': isLargeHeightPage, 'index-ctr-container': !showAgreement && !showOrder }"
    :show="drawerVisible"
  >
    <div
      v-if="!showResult"
      class="base-wrapper container"
    >
      <transition name="slide-left">
        <sign-index-v2
          v-show="!showAgreement && !showOrder"
          :open-type="openType"
          @toggleVisiblePage="toggleVisiblePage"
        />
      </transition>

      <transition name="slide-right">
        <keep-alive>
          <agreement
            v-if="showAgreement"
            :agreement-info="agreementInfo"
            :click-index="clickIndex"
            @toggleVisiblePage="toggleVisiblePage"
          />
        </keep-alive>
      </transition>

      <transition name="slide-right">
        <keep-alive>
          <order
            v-if="showOrder"
            :link="orderLink"
            title="请选择扣款顺序"
            @toggleVisiblePage="toggleVisiblePage"
          />
        </keep-alive>
      </transition>
    </div>
    <Result v-else />
  </vix-suspend-menu>
</template>

<script lang="ts">
import Vue from 'vue';
import { env, OpenType, VisiblePage } from '@/common';
import SignIndexV2 from '@/views/components/SignIndexV2.vue';
import Result from '@/views/result/result.vue';

export default Vue.extend({
  name: 'App',

  components: {
    SignIndexV2,
    Result,
    Agreement: () => import(/* webpackChunkName: 'agreement' */ '../components/Agreement.vue'),
    Order: () => import(/* webpackChunkName: 'order' */ '../order/Index.vue'),
  },

  data() {
    return {
      drawerVisible: true,
      showAgreement: false,
      showOrder: false,
      agreementInfo: [] as AgreementType[],
      clickIndex: 0, // 点击的第几个协议
      orderLink: '', // 扣款顺序设置页地址
      isLargeHeightPage: env.getIsLargeHeightPage(),
      openType: OpenType.InpaySign,
    };
  },
  computed: {
    showResult(): boolean {
      return this.$store.state.result.showResult;
    },
  },

  methods: {
    toggleVisiblePage(type: string, agreementInfo: AgreementType[] | string, index: number) {
      // 展示协议
      if (type === VisiblePage.agreement) {
        this.showAgreement = true;
        this.showOrder = false;
        this.clickIndex = index;
        this.agreementInfo = agreementInfo as AgreementType[];
        return;
      }
      // 展示扣款顺序
      if (type === VisiblePage.order) {
        this.showOrder = true;
        this.showAgreement = false;
        this.orderLink = agreementInfo as string;
        return;
      }
      // 回到首页
      if (type === VisiblePage.index) {
        this.showOrder = false;
        this.showAgreement = false;
      }
    },
  },
});
</script>

<style lang="less" scoped>
.suspend-container {
  .suspend-menu-box {
    .container {
      position: relative;
      height: 9.08rem;
      height: calc(9.08rem + constant(safe-area-inset-bottom));
      height: calc(9.08rem + env(safe-area-inset-bottom));
    }
  }
}
</style>
